import { Button, Grid, Typography } from "@material-ui/core";
import { Dispatch, SetStateAction } from "react";
import { toolbarStyles } from "./toolbarStyles";

type MeridiemButtonsProps = {
  date: Date;
  onChangeDate: Dispatch<SetStateAction<Date>>;
};

export const MeridiemButtons = ({
  date,
  onChangeDate,
}: MeridiemButtonsProps) => {
  const classes = toolbarStyles();

  const toggleMeridiem = (value: number) => {
    onChangeDate((prev) => {
      const newDate = new Date(prev);
      newDate.setHours(newDate.getHours() + value);
      return newDate;
    });
  };

  return (
    <Grid item xs={1} className={classes.meridiemContainer}>
      <Button
        className={`${classes.meridiemButton} ${
          date.getHours() < 12 ? classes.meridiemButtonSelected : ""
        }`}
        variant="text"
        onClick={() => (date.getHours() >= 12 ? toggleMeridiem(-12) : null)}
      >
        <Typography variant="subtitle1">AM</Typography>
      </Button>
      <Button
        className={`${classes.meridiemButton} ${
          date.getHours() >= 12 ? classes.meridiemButtonSelected : ""
        }`}
        variant="text"
        onClick={() => (date.getHours() < 12 ? toggleMeridiem(12) : null)}
      >
        <Typography variant="subtitle1">PM</Typography>
      </Button>
    </Grid>
  );
};
